import { TranslocoService } from "@ngneat/transloco";
import { ITooltipParams } from "ag-grid-community";
import { UtilCommon } from "app/shared/common/utils/UtilCommon";
import { UtilComponent } from "app/shared/common/utils/UtilComponent";
import { ControlType } from "app/shared/components/x-advanced-filter/x-advanced-filter.enum";
import { XAdvancedFilterControl, XAdvancedGroupControl } from "app/shared/components/x-advanced-filter/x-advanced-filter.model";

export const CANDIDATE_URL = {
  BACK_PAGE_LIST_CANDIDATE: "#manage/recruitment-candidate",
  BACK_PAGE_SAVED_LIST: (aggId) => `#manage/my-talent-pool/detail/${aggId}`,
  BACK_PAGE_SAVED_CANDIDATE: "#manage/my-talent-pool",
  LIST_PAGE: "#manage/recruitment-candidate",
  NAVIGATE_PAGE_DETAIL_CANDIDATE: "manage/recruitment-candidate/detail",
  NAVIGATE_PAGE_UPDATE_CANDIDATE: "manage/recruitment-candidate/update",
  NAVIGATE_PAGE_CANDIDATE_LIST: "manage/recruitment-candidate",
  NAVIGATE_PAGE_CANDIDATE_CREATE: "manage/recruitment-candidate/create",
  PREVIOUS_URL: ["/manage/recruitment-candidate", "/manage/my-talent-pool"],
  ATTRIBUTE_PAGE: "USER_ATTRIBUTE_RR_CANDIDATE"
};

export enum CallBackActionColumn {
  VIEW_CV = "VIEW_CV"
}

export const getColumnDefs = (
  utilComp: UtilComponent,
  translocoService: TranslocoService,
  callBackAction: (event: CallBackActionColumn, extraValue: { [key: string]: any }) => void
) => {
  return [
    {
      headerName: 'Select',
      field: 'aggId',
      cellRenderer: 'matCheckboxRenderer', // Sử dụng cellRenderer cho từng dòng
      headerComponent: 'matHeaderCheckbox',  // Sử dụng `mat-checkbox` cho header
      width: 70,
      maxWidth: 70,
    },
    utilComp.commonColumnNo("No", "no", 100),
    {
      headerName: translocoService.translate('CANDIDATE.LIST.VIEW_CV'),
      field: "id",
      cellRenderer: (item) => {
        return '<svg fill="#ED5A26" width="20px" height="20px" viewBox="0 0 846.66 846.66" style="cursor:pointer ;shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <defs> <style type="text/css">  .fil0 {fill:black;fill-rule:nonzero}  </style> </defs> <g id="Layer_x0020_1"> <path class="fil0" d="M539.75 794.68c27.15,0 27.15,41.29 0,41.29l-497.47 0c-11.4,0 -20.64,-9.25 -20.64,-20.65l0 -621.69c0,-5.7 2.31,-10.87 6.04,-14.6l162.3 -162.29c4.03,-4.03 9.31,-6.05 14.59,-6.05l466.89 0c11.4,0 20.65,9.25 20.65,20.65l0 361.36c0,27.16 -41.29,27.16 -41.29,0l0 -340.72 -437.7 0 -150.19 150.2 0 592.5 476.82 0zm-351.21 -181.98c-27.16,0 -27.16,-41.29 0,-41.29l306.67 0c27.16,0 27.16,41.29 0,41.29l-306.67 0zm0 -274.68c-27.16,0 -27.16,-41.29 0,-41.29l306.67 0c27.16,0 27.16,41.29 0,41.29l-306.67 0zm0 91.56c-27.16,0 -27.16,-41.29 0,-41.29l306.67 0c27.16,0 27.16,41.29 0,41.29l-306.67 0zm0 91.56c-27.16,0 -27.16,-41.29 0,-41.29l306.67 0c27.16,0 27.16,41.29 0,41.29l-306.67 0zm0 -274.68c-27.16,0 -27.16,-41.29 0,-41.29l306.67 0c27.16,0 27.16,41.29 0,41.29l-306.67 0zm496.57 238.25c49.84,0 90.24,40.4 90.24,90.24 0,18.1 -5.33,34.95 -14.5,49.07 37.57,24.93 61.47,66.08 64.13,111.2 1.59,27.06 -39.55,29.47 -41.13,2.42 -2.11,-35.69 -22.61,-67.48 -54.13,-84.24 -13.16,7.5 -28.38,11.78 -44.61,11.78 -17.56,0 -33.95,-5.01 -47.81,-13.69 -33.44,16.12 -55.6,49.04 -57.79,86.15 -1.59,27.05 -42.72,24.64 -41.13,-2.42 2.79,-47.18 28.75,-89.88 69.08,-114.28 -7.99,-13.47 -12.58,-29.19 -12.58,-45.99 0,-49.83 40.4,-90.24 90.23,-90.24zm0 41.29c-27.03,0 -48.94,21.92 -48.94,48.95 0,27.03 21.91,48.94 48.94,48.94 27.03,0 48.95,-21.91 48.95,-48.94 0,-27.03 -21.91,-48.95 -48.95,-48.95z"></path> </g> </g></svg>';
      },
      width: 100,
      onCellClicked: (event: any) => {
        callBackAction(CallBackActionColumn.VIEW_CV, {
          workerId: event?.data?.id,
        });
        event?.preventDefault?.();
      },
      tooltipValueGetter: (p: ITooltipParams) => {
        const firstLabel = translocoService.translate("CANDIDATE.LABEL.ACTON_VIEW");
        return firstLabel + " " + UtilCommon.getValueByLanguage(p?.data?.fullName);
      },
    },
    {
      headerName: translocoService.translate("CANDIDATE.LIST.FULL_NAME"),
      field: "fullName",
      cellRenderer: (item) => {
        return UtilCommon.getValueByLanguage(item?.value);
      },
      minWidth: 200,
    },
    {
      headerName: translocoService.translate("CANDIDATE.LABEL.BIRTHDAY"),
      field: "dob",
      cellRenderer: (item) => {
        return item?.value ? UtilCommon.formatDate(item?.value) : "";
      },
      minWidth: 100,

    },
    {
      headerName: translocoService.translate("CANDIDATE.LIST.GENDER"),
      field: "gender",
      cellRenderer: (item) => {
        return UtilCommon.getValueByLanguage(item?.value?.name)
      },
      minWidth: 100,
    },
    {
      headerName: translocoService.translate("CANDIDATE.LIST.MOBILE"),
      field: "mobile",
      cellRenderer: (item) => {
        return item?.value ? UtilCommon.formatPhoneNumber(item?.value) : "";
      },
      minWidth: 150,

    },
    {
      headerName: translocoService.translate("CANDIDATE.LIST.EMAIL"),
      field: "personalEmail",
      cellRenderer: (item) => {
        return item.value;
      },
      width: 200,
    },
    {
      headerName: translocoService.translate("CANDIDATE.LIST.STATUS"),
      field: "status",
      cellRenderer: (item) => {
        let stateValue = item?.value ?? item?.data?.state;
        stateValue = UtilCommon.capitalizeFirstCharacterOfWords(stateValue);
        return `${stateValue}${!!item?.data?.neverRecruitFlg ? ' <span style="margin-left: 8px; font-style: italic ;font-weight: 700 ;padding: 4px 8px;background: #f52b2b; border-radius: 30px;color: white; font-size: 8px ">Blacklist</span>' : ''}`;
      },
      minWidth: 180,
      width: 180,
      maxWidth: 180,
    },
    {
      headerName: translocoService.translate("CANDIDATE.LIST.REQUEST_CODE"),
      field: "requestCode",
      cellRenderer: (item) => {
        const extRequestCode = item?.data?.extRequestCode || "";
        let codeArray = item.value?.split(', ') || [];
        const uniqueCodesSet = new Set([...codeArray]);
        if (extRequestCode) {
          uniqueCodesSet.add(extRequestCode)
        }
        let result = '';

        if (uniqueCodesSet.size > 3) {
          result = Array.from(uniqueCodesSet).slice(0, 3).join(', ') + "...";
        } else {
          result = Array.from(uniqueCodesSet).join(', ');
        }

        return `<div>${result}</div>`;
      },
      tooltipValueGetter: (p: ITooltipParams) => {
        const extRequestCode = p?.data?.extRequestCode || "";
        let codeArray = p.value?.split(', ') || [];
        const uniqueCodesSet = new Set([...codeArray]);
        if (extRequestCode) {
          uniqueCodesSet.add(extRequestCode)
        }
        let result = '';

        if (uniqueCodesSet.size > 3) {
          result = Array.from(uniqueCodesSet).join(', ');
        } else {
          if (uniqueCodesSet.size == 1) {
            result = Array.from(uniqueCodesSet)?.[0]?.replace(",", '')
          } else {
            result = Array.from(uniqueCodesSet).join(', ');
          }
        }

        return `${result}`;
      },
      minWidth: 170,
      width: 170,
      maxWidth: 300,
    },
    {
      headerName: translocoService.translate("CANDIDATE.LIST.CURRENT_COMPANY"),
      field: "latestJob.company_name",
      cellRenderer: (data) => {
        if (!data || !data?.value) {
          return "";
        }
        return UtilCommon.getValueByLanguage(data?.value)
      },
      width: 200,
      tooltipValueGetter: (data: ITooltipParams) => {
        if (!data || !data?.value) {
          return "";
        }
        return UtilCommon.getValueByLanguage(data?.value);
      }
    },
    {
      headerName: translocoService.translate("CANDIDATE.LIST.JOB_TITLE"),
      field: "latestJob.job_title",
      cellRenderer: (data) => {
        if (!data || !data?.value) {
          return "";
        }
        return UtilCommon.getValueByLanguage(data?.value)
      },
      width: 200,
      maxWidth: 400,
      tooltipValueGetter: (data: ITooltipParams) => {
        if (!data || !data?.value) {
          return "";
        }
        return UtilCommon.getValueByLanguage(data?.value);
      }
    },
    {
      headerName: translocoService.translate("CANDIDATE.LABEL.CONSENT"),
      field: "consentFlg",
      cellRenderer: 'statusRendererComponent',
      minWidth: 130,
    },
    {
      headerName: translocoService.translate("CANDIDATE.LABEL.HAS_ACCOUNT"),
      field: "accountFlg",
      cellRenderer: 'statusRendererComponent',
      minWidth: 130,
    },
    {
      width: 200,
      headerName: translocoService.translate("CANDIDATE.LIST.UPDATE_USER"),
      field: "updateId",
      cellRenderer: (data) => {
        if (!data || !data?.value) {
          return "";
        }
        return UtilCommon.getNameFromEmail(data.value);
      },
    },
    {
      width: 200,
      headerName: translocoService.translate("CANDIDATE.LIST.UPDATE_DATE"),
      field: "updateDate",
      cellRenderer: (data) => {
        return UtilCommon.formatDate(data.value);
      },
    },
    {
      width: 200,
      headerName: translocoService.translate("CANDIDATE.LIST.CREATE_DATE"),
      field: "createDate",
      cellRenderer: (data) => {
        return UtilCommon.formatDate(data.value);
      },
    }
  ];
};

export enum LocalityKeyEnum {
  PROVINCE = "LOCALITY-1",
  DISTRICT = "LOCALITY-2",
  WARD = "LOCALITY-3",
  STATE = "LOCALITY-4",
}

export enum AttachmentCode {
  IDENTIFY = "AT001",
  AVATAR = "AT002",
  CV = "AT003",
  CERTIFICATE = "AT004",
  ATTACHMENT = "AT005",
  ASSIGNMENT = "AT007",
  ASSIGNMENT_RESULT = "AT008",
  SCANNED_QR_CODE = "AT009",
}

export enum FormType {
  CREATE = "CREATE",
  UPDATE = "UPDATE",
  VIEW = "VIEW"
}
export enum CandidateStatusEnum {
  OPENING = 'OPENING',
  PROCESSING = 'PROCESSING',
  OFFERED = 'OFFERED',
  EMPLOYEE = 'EMPLOYEE',
  BACKLIST = 'BACKLIST',
}

export enum SummaryTypeCodeEnum {
  NOTE = "SUTP001",
  SKILL = "SUTP004",
  TRACK = "SUTP005"
}

export enum ERPRecommenderStatus {
  DRAFT = 'DRAFT',
  REJECT = 'REJECT',
  APPROVE = 'APPROVE',
  NONE = 'NONE',
  PROCESSING = 'PROCESSING' // HRM-1357
}

export const POST_URL_PAGE = {
  DETAI: "/manage/recruitment-candidate/detail",
  LIST: "/manage/recruitment-candidate"
}

function generateYearList(startYear: number): { id: number; name: string }[] {
  const currentYear = new Date().getFullYear() + 20;
  const yearList = [];

  for (let year = currentYear; year >= startYear; year--) {
    yearList.push({ id: year, name: `${year}` });
  }

  return yearList;
}

// Usage
export const DEFAULT_YEAR_LIST = generateYearList(1990);

export const CANDIDATE_STATUSES = [
  {
    id: 'OPENING',
    label: 'Opening'
  },
  {
    id: 'PROCESSING',
    label: 'Processing'
  },
  {
    id: 'OFFERED',
    label: 'Offered'
  },
  {
    id: 'EMPLOYEE',
    label: 'Employee'
  }
]

export const FILTER_CONTROLS_CANDIDATE_NAME: XAdvancedFilterControl[] = [
  {
    value: '',
    type: ControlType.Input,
    required: true,
    fieldName: 'fullName',
    label: 'CANDIDATE.LIST.FULL_NAME'
  },
  {
    value: '',
    type: ControlType.Input,
    required: true,
    fieldName: 'lastName',
    label: 'CANDIDATE.LIST.LAST_NAME'
  },
  {
    value: '',
    type: ControlType.Input,
    required: true,
    fieldName: 'firstName',
    label: 'CANDIDATE.LIST.FIRST_NAME'
  }
]

export const FILTER_CONTROLS_CANDIDATE_NAME_JSON: XAdvancedFilterControl[] = [
  {
    value: '',
    type: ControlType.Input,
    required: true,
    fieldName: 'fullName.en',
    label: 'CANDIDATE.LIST.FULL_NAME'
  },
  {
    value: '',
    type: ControlType.Input,
    required: true,
    fieldName: 'lastName.en',
    label: 'CANDIDATE.LIST.LAST_NAME'
  },
  {
    value: '',
    type: ControlType.Input,
    required: true,
    fieldName: 'firstName.en',
    label: 'CANDIDATE.LIST.FIRST_NAME'
  }
]

export const FILTER_CONTROLS_CANDIDATE: XAdvancedFilterControl[] = [
  {
    value: '',
    type: ControlType.Input,
    required: true,
    fieldName: 'personalEmail',
    label: 'CANDIDATE.LIST.EMAIL'
  },
  {
    value: '',
    type: ControlType.DateTime,
    required: true,
    fieldName: 'dob',
    label: 'CANDIDATE.LABEL.DATE_OF_BIRTH'
  },
  {
    value: '',
    type: ControlType.Select,
    required: true,
    fieldName: 'genderId',
    isMultiple: true,
    label: 'CANDIDATE.LIST.GENDER'
  },
  {
    value: '',
    type: ControlType.Input,
    required: true,
    fieldName: 'mobile',
    label: 'CANDIDATE.LIST.MOBILE'
  },
  {
    value: '',
    type: ControlType.Select,
    required: true,
    fieldName: 'status',
    isMultiple: true,
    label: 'CANDIDATE.LIST.STATUS'
  },
  {
    value: '',
    type: ControlType.Input,
    required: true,
    fieldName: 'requestCode',
    label: 'CANDIDATE.LIST.REQUEST_CODE'
  },
  {
    value: '',
    type: ControlType.Input,
    required: true,
    fieldName: 'cvFtsValue',
    label: 'CANDIDATE.LIST.CV_CONTENT'
  },
  {
    value: '',
    type: ControlType.Input,
    required: true,
    fieldName: 'adsJobTitle',
    label: 'CANDIDATE.LIST.ADS_JOB_TITLE'
  },
  {
    value: '',
    type: ControlType.Input,
    required: true,
    fieldName: 'adsLocation',
    label: 'CANDIDATE.LIST.ADS_LOCATION'
  },
  {
    value: '',
    type: ControlType.Input,
    required: true,
    fieldName: 'adsSkill',
    label: 'CANDIDATE.LIST.ADS_SKILL'
  },
  {
    value: '',
    type: ControlType.Input,
    required: true,
    fieldName: 'adsCompany',
    label: 'CANDIDATE.LIST.ADS_COMPANY'
  },
  {
    value: '',
    type: ControlType.Input,
    required: true,
    fieldName: 'adsSchool',
    label: 'CANDIDATE.LIST.ADS_SCHOOL'
  },
  {
    value: '',
    type: ControlType.Numeric,
    required: true,
    fieldName: 'adsYearOfExperience',
    label: 'CANDIDATE.LIST.ADS_YEAR_OF_EXP'
  },
  {
    value: '',
    type: ControlType.Numeric,
    required: true,
    fieldName: 'adsYearInCurrentCompany',
    label: 'CANDIDATE.LIST.ADS_YEAR_CURR_COMPANY'
  }
]

export const GROUP_CONTROLS_CANDIDATE: XAdvancedGroupControl[] = [
  {
    fieldName: 'status',
    active: false,
    label: 'CANDIDATE.LIST.STATUS',
  }
]

export enum ChannelCodeEnum {
  Magazine = 'CT001',
  LinkedIn = 'CT002',
  Email = 'CT003',
  CareerSite = 'CT004',
  VngWebsite = 'CT005',
  ERP = 'CT006',
  Facebook = 'CT009',
  Github = 'CT010',
  Portfolio = 'CT012',
  Other_1 = 'CT011',
  Other_2 = 'CT013',
  Behance = 'CT015',
  Portfolio_Apply_Job = 'CT014'
}

export enum LegalDocTypeCode {
  PASSPORT = 'PASSPORT',
  CCCD_CMND = 'ID',
}

export enum ChangeEmployeeTypeEnum {
  EMPTY = 'EMPTY',
  STAFF_MOVEMENT = 'STAFF_MOVEMENT',
  CHANGE_EMPLOYEE_TYPE = 'CHANGE_EMPLOYEE_TYPE'
}

export enum ReferenceCheckCategory {
  Expertise = "REFERENCE_CHECK_EXPERTISE",
  Leadership = "REFERENCE_CHECK_LEADERSHIP",
  Interpersonal = "REFERENCE_CHECK_INTERPERSONAL",
  Overall = "REFERENCE_CHECK_OVERALL"
}